import React, { Component } from 'react'
import GoogleAnalytics from 'react-ga4'

GoogleAnalytics.initialize( [
	{
		trackingId: safeSiteData.google_analytics_id
	},
	{
		trackingId: safeSiteData.google_ads_id
	}
] )

const PageTracker = ( WrappedComponent, options = {} ) => {
	const trackPage = page => {
		// Will be tracked automatically with GA4.
	}

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location.pathname
			trackPage( page )
		}

		componentWillReceiveProps( nextProps ) {
			const currentPage = this.props.location.pathname
			const nextPage = nextProps.location.pathname

			if ( currentPage !== nextPage ) {
				trackPage( nextPage )
			}
		}

		render() {
			return <WrappedComponent { ...this.props } />
		}
	}

	return HOC
}

export default PageTracker



// WEBPACK FOOTER //
// ./components/page-tracker/page-tracker.jsx